import { useAppSelector } from "@/store/store";
import type Cropper from "cropperjs";
import { createContext, MutableRefObject, ReactNode, useContext, useEffect, useRef, useState } from "react";

type Operation = "crop" | "reset" | "flip-h" | "flip-v" | "rotate-cw" | "rotate-ccw";

interface CropContext {
    cropperRef: MutableRefObject<Cropper | null> | null;
    imageRef: MutableRefObject<HTMLImageElement | null> | null;
    operation: Operation | null;
    setOperation: (value: Operation | null) => void;
}

const CropContext = createContext<CropContext>({
    cropperRef: null,
    imageRef: null,
    operation: null,
    setOperation: () => {},
});

export const useBulkResizerImageProvider = () => useContext(CropContext);

export const BulkResizerImageProvider = ({ children }: { children: ReactNode }) => {
    const cropperRef = useRef<Cropper | null>(null);
    const imageRef = useRef<HTMLImageElement | null>(null);
    const [operation, setOperation] = useState<Operation | null>(null);
    const editImageModal = useAppSelector((store) => store.bulkResize.editImageModal);

    useEffect(() => {
        if (!editImageModal) setOperation(null);
    }, [editImageModal]);

    return (
        <CropContext.Provider value={{ cropperRef, imageRef, operation, setOperation }}>
            {children}
        </CropContext.Provider>
    );
};
